import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";


export const SimuladorIncentivosJefeTallerEficiencioOR = ({ rango = null, sueldo = 0, porcEficiencia, setEficiencia, tecnicosMas150, totalTecnicos }) => {

    const [state, setState] = useState({
        tecnicos: 0,
        tecnicosTotal: 0,
        cumplimiento: 0,
        porcentaje: 0,
        incentivo: 0,
    });

    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };
    useEffect(() => {
        // if (Number(state.tecnicosTotal !== 0) && Number(state.tecnicos !== 0)) {
        const cumplimiento = state.tecnicos === 0 ? 0 : truncar(Number(state.tecnicos) / Number(state.tecnicosTotal) * 100);
        var porcentaje = 0;
        var incentivo = 0;
        if (rango !== null) {
            rango.forEach((index) => {
                if (index.minimo <= porcEficiencia && index.maximo >= porcEficiencia) {
                    porcentaje = index.porcentaje;
                    incentivo =
                        Number(sueldo) * index.porcentaje;
                }
            });
        }

        setState({
            ...state,
            cumplimiento,
            porcentaje: porcentaje * 100,
            incentivo,
        });

        setEficiencia(incentivo)
        tecnicosMas150(state.tecnicos)
        totalTecnicos(state.tecnicosTotal)
        // }
    }, [state.tecnicos, state.tecnicosTotal, sueldo, rango]);

    // useEffect(() => {

    //     const porcentajeTecnicos = (Number(tecnicosMas150) / Number(totalTecnicos)) * 100;

    //     setState({
    //         ...state,
    //         porcentajeTecnicos: porcentajeTecnicos,
    //     });
    // }, [tecnicosMas150, totalTecnicos]);
    return (
        <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Tecnicos con mas de 150 horas</div>
                    <SimuladorNumericInput
                        name="tecnicos"
                        label=""
                        value={state.tecnicos}
                        disabled={false}
                        onChange={handleChange}
                        icono="numero"
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">Total técnicos</div>
                    <SimuladorNumericInput
                        name="tecnicosTotal"
                        label=""
                        value={state.tecnicosTotal}
                        disabled={false}
                        onChange={handleChange}
                        icono="numero"
                    />
                </div>
            </div>
            {/* <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Tecnicos con mas de 150 horas</div>
                    <SimuladorNumericInput
                        name="tecnicosMas150"
                        label=""
                        value={tecnicosMas150}
                        disabled={false}
                        onChange={handleChangeDatos}
                        icono="numero"
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">Total técnicos</div>
                    <SimuladorNumericInput
                        name="totalTecnicos"
                        value={totalTecnicos}
                        onChange={handleChangeDatos}
                        disabled={false}
                        icono="numero"
                    />
                </div>
            </div> */}

            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">% Tecnicos</div>
                    <SimuladorNumericInput
                        name="cumplimiento"
                        label=""
                        value={state.cumplimiento}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>

                <div className="input-section">
                    <div className="input-title-label">% de Incentivo</div>
                    <SimuladorNumericInput
                        name="porcentajeTecnicos"
                        label=""
                        value={state.porcentaje}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label-incentive">Tu incentivo es de:</div>
                    <SimuladorNumericInput
                        name="incentivo"
                        label=""
                        value={state.incentivo}
                        disabled={true}
                        icono="pesos"
                        inputTotal="si"
                    />
                </div>
            </div>
        </div>
    );
};
